<template>
	<div>
		<v-card flat color="transparent">
			<v-card-text>
				<v-row align="center">
					<v-col cols="12" md="2" lg="1" xl="2" class="mx-0 px-0 mr-md-2 py-lg-0">
						<alternativeAutocompleteOne
                            :items="years"
                            :valueInput="selectedYear"
                           
                            @valueChange="(v) => {selectedYear = v}"
                            @onChange="(v) => {this.getWeeks()}"
                           
                            :label="'Año'"
                            classesContainer="width-auto"
                        ></alternativeAutocompleteOne>
					</v-col>
                    <v-col cols="12" md="3" lg="3" xl="3" class="mx-0 px-0 mr-md-2 py-lg-0">
						<alternativeAutocompleteOne
                            classesContainer="f-width"
                            :items="weeks"
                            label="Semana"
                            :valueInput="selectedWeek"
                            :loading="false"
                            @valueChange="(v) => {selectedWeek = v; this.index();}"
                        ></alternativeAutocompleteOne>
					</v-col>
                   
                    <v-col cols="12" md="2" lg="2" xl="1" class="mx-0 px-0 mr-md-2 py-lg-0">
						<alternativeAutocompleteOne
                            classesContainer="f-width"
                            :items="filters"
                            label="Mostrar"
                            :valueInput="selectedFilter"
                            :loading="false"
                            @valueChange="(v) => {selectedFilter = v; this.index();}"
                        ></alternativeAutocompleteOne>
					</v-col>
                   
                    
					<v-spacer></v-spacer>
					<v-col  cols="12" md="4" class="mx-0 py-lg-0 ">
                        <v-row justify="end">
                            <!-- <iconButton class="mr-2" :props="corpExportBtnData"></iconButton> -->
                            <iconButton :props="pdfBtnData" class="mr-2">
                                <template slot="imgIcon">
                                    <img :src="pdfIcon" width="24" :class="pdfBtnData.disabled ? `filter-grey` : `filter-grey-darken-3`">
                                </template>
                            </iconButton>
                            
                            <v-menu offset-y>
            
                                <template v-slot:activator="{ on }">
                                    <iconButton v-on="on" :props="{...exportBtnData, on:on}"></iconButton>
                                </template>
                                <v-list>
                                   
                                    <v-list-item  link @click="this.export">
                                        <v-list-item-title>Descargar todo el reporte</v-list-item-title>
                                    </v-list-item>
                                    <v-list-item  link @click="this.corpExport">
                                        <v-list-item-title>Descargar solo pagos realizados</v-list-item-title>
                                    </v-list-item>
                                </v-list>
                            </v-menu>
                        </v-row>
					</v-col>

				</v-row>
				<v-row>
					<v-col class="mx-0 px-0">
						<v-card class="index-card ">
                            <v-card-text  class="text-center">
                                <v-col cols="12" >
                                    <div class="week-report-title mb-2">
                                        <span>Flujo semanal</span>
                                    </div>
                                    <div v-if="loading">
                                        <v-progress-circular
                                        indeterminate
                                        color="primary"
                                        :size="50"
                                        ></v-progress-circular>
                                    </div>
                                    <div  v-if="!loading">
                                        <div v-if="selectedFilter == 'all'" class="week-report-subtitles-container mb-1">
                                            <span>Saldo inicial en bancos</span>
                                            <span>{{totalInitialBalanceValue}}</span>
                                        </div>
                                        <div v-if="selectedFilter == 'all'" class="week-report-subtitles-container week-report-subtitles-currency mb-2">
                                            <span>Tipo de cambio</span>
                                            <span>{{initialBalanceTitle}}</span>
                                        </div>

                                        <v-row v-if="selectedFilter == 'all'">
                                            <v-col>
                                                <table-items :props="tableInitialBalancesProps"  :items="tableInitialBalancesProps.items">
                                                    <template v-slot:item.total="props">
                                                        <span :class="(props.index+1) == tableInitialBalancesProps.items.length ? 'font-weight-bold': ''">{{props.item.total}}</span>
                                                    </template>
                                                </table-items>
                                            </v-col>
                                        </v-row>


                                        <div v-if="selectedFilter == 'all'" class="week-report-subtitles-container mb-2">
                                            <span>Ingresos sobre venta</span>
                                            <span>{{totalIncomeValue}}</span>
                                        </div>

                                        <v-row v-if="selectedFilter == 'all'">
                                            <v-col>
                                                <table-items :props="tableIncomesProps"  :items="tableIncomesProps.items">
                                                    <template v-slot:item.total_mxn="props">
                                                        <span :class="(props.index+1) == tableIncomesProps.items.length ? 'font-weight-bold': ''">{{props.item.total_mxn}}</span>
                                                    </template>
                                                    <template v-slot:item.total_usd="props">
                                                        <span :class="(props.index+1) == tableIncomesProps.items.length ? 'font-weight-bold': ''">{{props.item.total_usd}}</span>
                                                    </template>
                                                    <template v-slot:item.date="props">
                                                        <span :class="(props.index+1) == tableIncomesProps.items.length ? 'font-weight-bold': ''">{{props.item.date}}</span>
                                                    </template>
                                                </table-items>
                                            </v-col>
                                        </v-row>

                                        <div v-if="selectedFilter == 'all'" class="week-report-subtitles-container mb-2">
                                            <span>Otros Ingresos</span>
                                            <span>{{totalOtherIncomeValue}}</span>
                                        </div>

                                        <v-row v-if="selectedFilter == 'all'">
                                            <v-col>
                                                <table-items :props="tableOtherIncomesProps"  :items="tableOtherIncomesProps.items">
                                                    <template v-slot:item.total_mxn="props">
                                                        <span :class="(props.index+1) == tableOtherIncomesProps.items.length ? 'font-weight-bold': ''">{{props.item.total_mxn}}</span>
                                                    </template>
                                                    <template v-slot:item.total_usd="props">
                                                        <span :class="(props.index+1) == tableOtherIncomesProps.items.length ? 'font-weight-bold': ''">{{props.item.total_usd}}</span>
                                                    </template>
                                                    <template v-slot:item.date="props">
                                                        <span :class="(props.index+1) == tableOtherIncomesProps.items.length ? 'font-weight-bold': ''">{{props.item.date}}</span>
                                                    </template>
                                                </table-items>
                                            </v-col>
                                        </v-row>


                                        <div class="week-report-subtitles-container mb-0">
                                            <span>CXP</span>
                                            <span>{{ut.currencyFormat(expensesGrandTotal)}}</span>
                                        </div>

                                        <v-row>
                                            <v-col>
                                                
                                                <div class="mb-2 mt-1"  v-for="(expense, index) in expensesListData" :key="index">
                                                    <div class="week-report-cxp-subtitles-container mb-0">
                                                        <span>{{ expense.title }}</span>
                                                        <span>{{ut.currencyFormat(expense.total)}}</span>
                                                    </div>
                                                    <v-expansion-panels flat class="parent-expansion-custom" multiple>
                                                        <v-expansion-panel v-for="(expenseItem, indexj) in expense.expenseItem" :key="indexj" class="week-report-cxp-subitem-expan elevation-0">
                                                            <v-expansion-panel-header class="pb-0 mb-0 week-report-cxp-subitem-icon-cont-text">
                                                            {{ expenseItem.title }}
                                                            <template v-slot:actions>
                                                                <div class="week-report-cxp-subitem-icon-cont">
                                                                    <p class="pb-0 mb-0 week-report-cxp-subitem-icon-cont-text mr-3">{{ut.currencyFormat(expenseItem.total)}}</p>
                                                                    <v-icon color="">
                                                                        $expand
                                                                    </v-icon>
                                                                </div>
                                                            </template>
                                                            </v-expansion-panel-header>
                                                            <v-expansion-panel-content class="px-0 expand-custom" >
                                                                <table-items class="" :showExpand="false" :props="{...expenseItem.tableData, hideHeaders:false, showSelect:false}"  :items="expenseItem.tableData.items">
                                                                    
                                                                    <template v-slot:item.date="props2">
                                                                        <div class="week-report-expenses-check-container">
                                                                            <v-checkbox
                                                                                dense
                                                                                :ripple="false"
                                                                                v-if="props2.item.showCheck"
                                                                                color="primary"
                                                                                v-model="props2.item.checked"
                                                                                hide-details="auto"
                                                                                :disabled="props2.item.disableCheck"
                                                                                :indeterminate="props2.item.disableCheck"
                                                                                indeterminate-icon="mdi-checkbox-blank"
                                                                                @change="(v) => {
                                                                                    checkboxExpenseChanged(v, props2.item); 
                                                                                    //checkboxUpdateTotalProvider(v, props2.item, expenseItem, expense)
                                                                                }"
                                                                            ></v-checkbox>
                                                                        <span :class="`${props2.item.setBold ? 'font-weight-bold': ''} `">{{props2.item.date}}</span>

                                                                        </div>
                                                                    </template>
                                                                    <template v-slot:item.folio_int="props2">
                                                                        <span @click="() => openLink(props2.item.invoice_pdf_path)" :class="`${props2.item.invoice_pdf_path != null &&  props2.item.invoice_pdf_path != '' ? 'text-decoration-underline clic': ''} `">{{props2.item.folio_int}}</span>
                                                                    </template>
                                                                    <template v-slot:item.total_mxn="props2">
                                                                        <span :class="`${props2.item.setBold ? 'font-weight-bold': ''} ${props2.item.status == 'vencida' ? 'red--text' :  (props2.item.disableCheck || props2.item.checked ) && props2.item.amount > 0 ?  'week-report-expenses-checked-number': ''}`">{{props2.item.total_mxn}}</span>
                                                                    </template>
                                                                    <template v-slot:item.total_usd="props2">
                                                                        <span :class="`${props2.item.setBold ? 'font-weight-bold': ''} ${props2.item.status == 'vencida' ? 'red--text' :  (props2.item.disableCheck || props2.item.checked ) && props2.item.amount > 0 ?  'week-report-expenses-checked-number': ''}`">{{props2.item.total_usd}}</span>
                                                                    </template>
                                                                </table-items>
                                                            </v-expansion-panel-content>
                                                        </v-expansion-panel>
                                                        
                                                    </v-expansion-panels>
                                                </div>
                                                
                                            </v-col>
                                        </v-row>
                                        

                                        
                                        <v-row >
                                            <v-col>
                                                <table-items class="week-report-expenses-summary-table mb-3" :showExpand="false" :props="tableExpensesBalancesProps"  :items="tableExpensesBalancesProps.items">
                                                    <template v-slot:item.total_mxn="props">
                                                        <span :class="`${props.item.setBold ? 'font-weight-bold': ''} ${props.item.status == 'vencida'? 'red--text' :  (props.item.disableCheck || props.item.checked ) && props.item.currency == 'MXN' ?  'week-report-expenses-checked-number': ''}`">{{props.item.total_mxn}}</span>
                                                    </template>
                                                    <template v-slot:item.total_usd="props">
                                                        <span :class="`${props.item.setBold ? 'font-weight-bold': ''} ${(props.item.disableCheck || props.item.checked ) && props.item.currency == 'USD' ? 'week-report-expenses-checked-number': ''}`">{{props.item.total_usd}}</span>
                                                    </template>
                                                </table-items>
                                            </v-col>
                                        </v-row>
                                        <v-divider v-if="selectedFilter == 'all'"></v-divider>
                                        <div class="mt-1"></div>
                                        <v-divider v-if="selectedFilter == 'all'"></v-divider>
                                        <v-row v-if="selectedFilter == 'all'">
                                            <v-col>
                                                <table-items class="hide-header-table-custom" :showExpand="false" :props="tableFinalBalancesProps"  :items="tableFinalBalancesProps.items">
                                                    <template v-slot:item.total="props">
                                                        <span :class="`${props.item.total.includes('-') ? 'red--text': ''} ${props.item.setBold ? 'font-weight-bold' : ''}`">{{props.item.total}}</span>
                                                    </template>
                                                </table-items>
                                                <v-divider></v-divider>
                                                <div class="week-report-subtitles-container mb-2">
                                                    <span>SALDO FINAL</span>
                                                    <span>{{lastTotal}}</span>
                                                </div>
                                            </v-col>
                                        </v-row>


                                    </div>
                                    
                                    
                                </v-col>
                            </v-card-text>
                        </v-card>
					</v-col>
				</v-row>
			</v-card-text>
		</v-card>

     
	</div>
</template>
<script>
import PageStateManager from '../../../helpers/PageStateManager';
import Utils from '../../../helpers/Utils';
import pdfIcon from '../../../assets/pdf_icon_2.svg'
import TableItemsVue from '../../incomes/TableItems.vue';
export default {
    components: {
       'table-items': TableItemsVue
    },
    data(){
		return {
            currentCurrencyValue: 0,
            totalInitialBalanceValue: 0,
            totalIncomeValue: 0,
            totalOtherIncomeValue: 0,
            expensesGrandTotal: 0,
            initialBalanceTitle: '',
            lastTotal:'',
            pdfIcon: pdfIcon,
            loading: false,
            ut: Utils,
            selectedYear: PageStateManager.getState(this.$router.history.current.path, 'selectedYear')??'',
            years: [
                
            ],
            selectedWeek: PageStateManager.getState(this.$router.history.current.path, 'selectedWeek')??'',
            weeks: [
                
            ],
            actualWeek: '',
            filters: [
                {text: "Todos", value:"all"},
                {text: "Solo lo pagado", value:"payments"},
            ],
            selectedFilter: PageStateManager.getState(this.$router.history.current.path, 'selectedFilter')??'all',
			
            corpExportBtnData: {
                hasTooltip:true,
                tooltip: 'Exportar corporativo',
                color:'primary',
                iconColor:'grey darken-3',
                height:'35',
                icon: "mdi-archive-arrow-down",
                iconClass: "",
				block: false,
                loading: false,
                disabled: false,
                click: ()=>{this.corpExport();}
            },
            exportBtnData: {
                hasTooltip:true,
                tooltip: 'Exportar excel',
                color:'primary',
                iconColor:'grey darken-3',
                height:'35',
                icon: "mdi-microsoft-excel",
                iconClass: "",
				block: false,
                loading: false,
                disabled: false,
                click: ()=>{}
            },
            pdfBtnData: {
                hasTooltip:true,
                tooltip: 'Exportar PDF',
                customIcon:true,
                color:'primary',
                iconColor:'grey darken-3',
                height:'35',
                text: "Generar pdf",
                icon: "mdi-progress-download",
                iconClass: "",
				to: "",
				block: false,
                loading: false,
                click: ()=>{this.pdf();}
            },

            tableInitialBalancesProps: {
				headers: [
                     {
						text: 'Cuenta',
						align: 'left small-th-no-padding',
						value: 'bank_account_name',
                        sortable: false,
						class: 'table-b-border black--text'
					},
					{
						text: 'USD',
						align: 'right small-th-no-padding',
						value: 'total_usd',
                        width: '12%',
						sortable: false,
						class: 'table-b-border black--text'
					},
                    {
						text: 'MXN',
						align: 'right small-th-no-padding',
						value: 'total_mxn',
                        width: '12%',
						sortable: false,
						class: 'table-b-border black--text'
					},
                    {
						text: 'Saldo',
						align: 'right small-th-no-padding',
						value: 'total',
                        width: '12%',
						sortable: false,
						class: 'table-b-border black--text'
					},
                   
				],
				items: [],
				search: '',
				loading: false,
                keyValue: 0,
			},
            tableIncomesProps: {
				headers: [
                    {
						text: 'Fecha',
						align: 'left small-th-no-padding',
						value: 'date',
                        sortable: false,
						class: 'table-b-border black--text'
					},
                    {
						text: 'Factura',
						align: 'center small-th-no-padding',
						value: 'folio_int',
                        sortable: false,
						class: 'table-b-border black--text'
					},
                    {
						text: 'Emisor',
						align: 'center small-th-no-padding',
						value: 'sender_name',
                        sortable: false,
						class: 'table-b-border black--text'
					},
                    {
						text: 'Concepto',
						align: 'center small-th-no-padding',
						value: 'concept_name',
                        sortable: false,
						class: 'table-b-border black--text'
					},
                    {
						text: 'Cuenta',
						align: 'center small-th-no-padding',
						value: 'bank_account_name',
                        width: '12%',
                        sortable: false,
						class: 'table-b-border black--text'
					},
					{
						text: 'USD',
						align: 'right small-th-no-padding',
						value: 'total_usd',
                        width: '12%',
						sortable: false,
						class: 'table-b-border black--text'
					},
                    {
						text: 'MXN',
						align: 'right small-th-no-padding',
						value: 'total_mxn',
                        width: '12%',
						sortable: false,
						class: 'table-b-border black--text'
					},
                   
                   
				],
				items: [],
				search: '',
				loading: false,
                keyValue: 0,
			},
            tableOtherIncomesProps: {
				headers: [
                    {
						text: 'Fecha',
						align: 'left small-th-no-padding',
						value: 'date',
                        sortable: false,
						class: 'table-b-border black--text'
					},
                    {
						text: 'Factura',
						align: 'center small-th-no-padding',
						value: 'folio_int',
                        sortable: false,
						class: 'table-b-border black--text'
					},
                    {
						text: 'Emisor',
						align: 'center small-th-no-padding',
						value: 'sender_name',
                        sortable: false,
						class: 'table-b-border black--text'
					},
                    {
						text: 'Concepto',
						align: 'center small-th-no-padding',
						value: 'concept_name',
                        sortable: false,
						class: 'table-b-border black--text'
					},
                    {
						text: 'Cuenta',
						align: 'center small-th-no-padding',
						value: 'bank_account_name',
                        width: '12%',
                        sortable: false,
						class: 'table-b-border black--text'
					},
					{
						text: 'USD',
						align: 'right small-th-no-padding',
						value: 'total_usd',
                        width: '12%',
						sortable: false,
						class: 'table-b-border black--text'
					},
                    {
						text: 'MXN',
						align: 'right small-th-no-padding',
						value: 'total_mxn',
                        width: '12%',
						sortable: false,
						class: 'table-b-border black--text'
					},
                   
                   
				],
				items: [],
				search: '',
				loading: false,
                keyValue: 0,
			},

            tableFinalBalancesProps: {
				headers: [
                    {
						text: 'Cuenta',
						align: 'left small-th-no-padding',
						value: 'bank_account_name',
                        sortable: false,
						class: 'table-b-border black--text'
					},
                    
					{
						text: 'USD',
						align: 'right small-th-no-padding',
						value: 'total_usd',
                        width: '12%',
						sortable: false,
						class: 'table-b-border black--text'
					},
                    {
						text: 'MXN',
						align: 'right small-th-no-padding',
						value: 'total_mxn',
                        width: '12%',
						sortable: false,
						class: 'table-b-border black--text'
					},
                      {
						text: 'Total',
						align: 'right small-th-no-padding',
						value: 'total',
                        width: '12%',
						sortable: false,
						class: 'table-b-border black--text'
					},
                   
                   
				],
				items: [],
				search: '',
				loading: false,
                keyValue: 0,
			},

            expensesListData:[
                {
                    title: 'administracion general 2026',
                    total: '',
                    expenseItem:[
                        // {
                        //     title: 'aliargq',
                        //     total: '',
                        //     tableData: {},
                        // }
                    ]
                }

            ],

            tableExpensesProps: {
				headers: [
                    {
						text: 'Fecha',
						align: 'left small-th-no-padding',
						value: 'date',
                        sortable: false,
                        width: '12%',
						class: 'table-b-border black--text'
					},
                    {
						text: 'Factura',
						align: 'center small-th-no-padding',
						value: 'folio_int',
                        width: '14%',
                        sortable: false,
						class: 'table-b-border black--text'
					},
                    {
						text: 'Vencimiento',
						align: 'center small-th-no-padding',
						value: 'due_date',
                        sortable: false,
                        width: '12%',
						class: 'table-b-border black--text'
					},
                    {
						text: 'Receptor',
						align: 'center small-th-no-padding',
						value: 'emitter_name',
                        width: '14%',
                        sortable: false,
						class: 'table-b-border black--text'
					},
                    {
						text: 'Concepto',
						align: 'center small-th-no-padding',
						value: 'concept_name',
                        width: '14%',
                        sortable: false,
						class: 'table-b-border black--text'
					},
                    {
						text: 'Cuenta',
						align: 'center small-th-no-padding',
						value: 'bank_account_name',
                        width: '14%',
                        sortable: false,
						class: 'table-b-border black--text'
					},
					{
						text: 'USD',
						align: 'right small-th-no-padding',
						value: 'total_usd',
                        width: '12%',
						sortable: false,
						class: 'table-b-border black--text'
					},
                    {
						text: 'MXN',
						align: 'right small-th-no-padding',
						value: 'total_mxn',
                        width: '12%',
						sortable: false,
						class: 'table-b-border black--text'
					},
                   
                   
				],
				items: [],
                showExpand:false,
				search: '',
				loading: false,
                keyValue: 0,
                expanded:[1],
                
			},

            tableExpensesBalancesProps: {
				headers: [
                    {
						text: 'Totales',
						align: 'left small-th-no-padding',
						value: 'title',
                        sortable: false,
						class: 'table-b-border black--text'
					},
                    
					// {
					// 	text: 'USD',
					// 	align: 'right small-th-no-padding',
					// 	value: 'total_usd',
                    //     width: '12%',
					// 	sortable: false,
					// 	class: 'table-b-border black--text'
					// },
                    {
						text: 'MXN',
						align: 'right small-th-no-padding',
						value: 'total_mxn',
                        width: '12%',
						sortable: false,
						class: 'table-b-border black--text'
					},
                   
                   
                   
				],
				items: [],
				search: '',
				loading: false,
                keyValue: 0,
			},



            





			
		}
	},

  
    watch: {
        /**
         * save change
         */
        [`selectedYear`]: function (v) {
            // console.log(this.selectedYear, "changed")
            PageStateManager.setState(this.$router.history.current.path, 'selectedYear', this.selectedYear);
            this.getWeeks(v)
        },
        [`selectedWeek`]: function () {
            console.log(this.selectedWeek, "changed")
            PageStateManager.setState(this.$router.history.current.path, 'selectedWeek', this.selectedWeek);
        },
        [`selectedFilter`]: function () {
            console.log(this.selectedFilter, "changed")
            PageStateManager.setState(this.$router.history.current.path, 'selectedFilter', this.selectedFilter);
        },
       
       
    },
    

	mounted(){
        this.getYears();
        this.getWeeks();
        this.getSelectedDates();
        // window.addEventListener('resize', this.onResize, { passive: true });
        // this.onResize();
        // if(!this.loading)
        //     this.index();
	},

    methods: {
        openLink(url){
            if(url == null || url == '') return;
            window.open(url,"_BLANK")
        },
        subtotalSpecialExpense(amount, currency){
            if(currency == 'MXN')
                return amount;

            const amountToMxn = amount * this.currentCurrencyValue;
            return amountToMxn;
        },
        checkboxExpenseChanged(value, item){
            let subtotalRow = this.tableExpensesBalancesProps.items.find((x) => x.title == 'TOTAL PAGOS AUTORIZADOS');
            let totalRow = this.tableExpensesBalancesProps.items.find((x) => x.title == 'SALDO TOTAL CXP');
            let finalRow = this.tableFinalBalancesProps.items.find((x) => x.bank_account_name == 'Saldo Final');

            let amountToFinal = 0;
            if(subtotalRow != undefined){
                if(item.currency == 'MXN'){
                    subtotalRow.mxn = value ? subtotalRow.mxn + item.amount :  subtotalRow.mxn - item.amount;
                    totalRow.total = value ? totalRow.total + item.amount :  totalRow.total - item.amount;
                    amountToFinal = item.amount;
                }
                if(item.currency == 'USD'){
                    subtotalRow.usd = value ? subtotalRow.usd + item.amount :  subtotalRow.usd - item.amount;
                    //convert to mxn
                    const amountToMxn = item.amount * this.currentCurrencyValue;
                    totalRow.total = value ? totalRow.total + amountToMxn : totalRow.total - amountToMxn;
                    amountToFinal = amountToMxn;
                }
            }

            if(totalRow != undefined){
                // uncommend to make changes on 'TOTAL PAGOS AUTORIZADOS' col
                // //subtotalRow.total_mxn = Utils.currencyFormat(subtotalRow.mxn, '');
                // //subtotalRow.total_usd = Utils.currencyFormat(subtotalRow.usd, '');
                totalRow.total_mxn = Utils.currencyFormat(totalRow.total, '');
            }
            

            if(finalRow != undefined){
                finalRow.total_raw = value ? finalRow.total_raw - amountToFinal : finalRow.total_raw + amountToFinal;
                finalRow.total = Utils.currencyFormat(finalRow.total_raw, '');
            }
            this.checkboxUpdateNewTotalsV2Row(value, item)
            this.checkboxUpdateOTRow(value, item);
            this.updateFinalBalanceExpensesV2Row();
        },
        updateFinalBalanceExpensesV2Row(){
            let totalAutorized = this.tableExpensesBalancesProps.items.find((x) => x.title.includes("TOTAL AUTORIZADO CXP SEMANA"));
            let finalTotal = this.tableExpensesBalancesProps.items.find((x) => x.title.includes("SALDO FINAL CXP SEMANA"));
            if(totalAutorized != undefined && finalTotal != undefined){
                finalTotal.total = finalTotal.total_raw;
                finalTotal.total = finalTotal.total - totalAutorized.total;
                finalTotal.total_mxn = Utils.currencyFormat(finalTotal.total, '');
            }
        },
        checkboxUpdateNewTotalsV2Row(value, item){
            let totalRow = this.tableExpensesBalancesProps.items.find((x) => x.title.includes("TOTAL AUTORIZADO CXP SEMANA"));
            // let amountToFinal = 0;
            if(totalRow != undefined){
                if(item.currency == 'MXN'){
                    // subtotalRow.mxn = value ? subtotalRow.mxn + item.amount :  subtotalRow.mxn - item.amount;
                    totalRow.total = value ? totalRow.total + item.amount :  totalRow.total - item.amount;
                    // amountToFinal = item.amount;
                }
                if(item.currency == 'USD'){
                    // subtotalRow.usd = value ? subtotalRow.usd + item.amount :  subtotalRow.usd - item.amount;
                    //convert to mxn
                    const amountToMxn = item.amount * this.currentCurrencyValue;
                    totalRow.total = value ? totalRow.total + amountToMxn : totalRow.total - amountToMxn;
                    // amountToFinal = amountToMxn;
                }
            }

            if(totalRow != undefined){
                //uncommend to make changes on 'TOTAL PAGOS AUTORIZADOS' col
                // //subtotalRow.total_mxn = Utils.currencyFormat(subtotalRow.mxn, '');
                // //subtotalRow.total_usd = Utils.currencyFormat(subtotalRow.usd, '');
                totalRow.total_mxn = Utils.currencyFormat(totalRow.total, '');
            }
        },
        checkboxUpdateOTRow(value, item){
            console.log(value, item, "updateot ")
            let totalRow = this.tableExpensesBalancesProps.items.find((x) => x.title == `cxp autorizadas ${item.reference_name}`);
            // let totalRow = this.tableExpensesBalancesProps.items.find((x) => x.title == 'SALDO TOTAL CXP');
            // let finalRow = this.tableFinalBalancesProps.items.find((x) => x.bank_account_name == 'Saldo Final');
            console.log(totalRow, "totallll")
            // let amountToFinal = 0;
            if(totalRow != undefined){
                if(item.currency == 'MXN'){
                    // subtotalRow.mxn = value ? subtotalRow.mxn + item.amount :  subtotalRow.mxn - item.amount;
                    totalRow.total = value ? totalRow.total + item.amount :  totalRow.total - item.amount;
                    // amountToFinal = item.amount;
                }
                if(item.currency == 'USD'){
                    // subtotalRow.usd = value ? subtotalRow.usd + item.amount :  subtotalRow.usd - item.amount;
                    //convert to mxn
                    const amountToMxn = item.amount * this.currentCurrencyValue;
                    totalRow.total = value ? totalRow.total + amountToMxn : totalRow.total - amountToMxn;
                    // amountToFinal = amountToMxn;
                }
            }

            if(totalRow != undefined){
                //uncommend to make changes on 'TOTAL PAGOS AUTORIZADOS' col
                // //subtotalRow.total_mxn = Utils.currencyFormat(subtotalRow.mxn, '');
                // //subtotalRow.total_usd = Utils.currencyFormat(subtotalRow.usd, '');
                totalRow.total_mxn = Utils.currencyFormat(totalRow.total, '');
            }
        },
        checkboxUpdateTotalProvider(checkValue, item, providerItem, expenseOt){
            let amountToFinal = 0;
            if(item.currency == 'MXN'){
            
                amountToFinal = item.amount;
            }
            if(item.currency == 'USD'){
                // //convert to mxn
                const amountToMxn = item.amount * this.currentCurrencyValue;
                amountToFinal = amountToMxn;
            }

            //update provider header
            providerItem.total = checkValue ? providerItem.total + amountToFinal : providerItem.total - amountToFinal
            //update ot header
            expenseOt.total = checkValue ? expenseOt.total + amountToFinal : expenseOt.total - amountToFinal
        },
        getSelectedDates()
        {
            const dates = this.selectedWeek.split('|');
            return {start_date: dates[0], end_date:dates[1]};
        },
        getWeeks()
        {
            const utils = new Utils();
            const weeks = utils.getISOWeeksOfYear(+this.selectedYear);

            this.weeks = weeks.map( (x)=> ( {
                active: x.active,
                text: `Semana ${x.week} ( ${x.text} )`,
                value: `${x.start}|${x.end}`
            } ) );

            const current = weeks.find( x => x.active );
            if(current && this.selectedWeek == ''){
                this.actualWeek = `${current.start}|${current.end}`;
                this.selectedWeek = `${current.start}|${current.end}`;
            }
            this.index();
        },
       
        onResize () {
            
            // if(window.innerWidth <= 960){
            //     this.exportBtnData.block = true;
                
            // }
            // else{
                
            //     this.exportBtnData.block = false;
            // }
        },
        method_handler(object){
            // console.log(object);
			this[object.methodName](object.parameters)
		},
        handleOptions(object){
            object.options[`search`] = this.tableProps.search;
			this.options = object.options;
            PageStateManager.setState(this.$router.history.current.path, 'optionsIndexTable', JSON.stringify(this.options));
			// this.index();
		},



        sortData(data, by){
            if(data == null) return data;

            if(Object.hasOwn(data, 'incomes')){
                data.incomes.data.incomes = data?.incomes?.data?.incomes.sort((a, b) => b[by].localeCompare(a[by]))??[];
                data.incomes.data.other_incomes = data?.incomes?.data?.other_incomes?.sort((a, b) => b[by].localeCompare(a[by]));

            }


            // Object.keys(data?.expenses?.data).forEach(key => {
            //     data.expenses.data[key] = data.expenses.data[key].sort((a, b) => b[by].localeCompare(a[by]));
            // });
            return data;
        },
        sortChronosFulfillment(data, key){
            if(data == null) return data;
            /**
                1.- ADMINISTRACION            
                2.- HCP SLP             
                3.- HCP SLP HD             
                4.- EUROPA             
                5.- HCP QRO
            */
            const otsValues = [
                'ADMINISTRACIÓN GENERAL',
                'HAU CAN PARK SLP',
                'HD',
                'EUROPA',
                'HAU CAN PARK QRO'
            ];
            let orderResult = [];
            otsValues.forEach(lookFor => {
                const found = data.findIndex((x) => x[key] == lookFor);
                if(found != -1){
                    orderResult.push(JSON.parse(JSON.stringify(data[found])));
                    data.splice(found, 1)
                }
            });
            
            return [...orderResult, ...data];
        },

        processRequestExpenses(requestData){
            this.expensesListData = [];
            let expenses = this.processExpensesData(requestData.expenses.data);
            let subtotalCheckable = 0;
            this.expensesGrandTotal = 0;
            expenses.forEach(fullItem => {
                let expenseItems = [];
                for (let i = 0; i < fullItem.data.length; i++) {
                    const provData = fullItem.data[i];
                    let tableProps = JSON.parse(JSON.stringify(this.tableExpensesProps));
                    tableProps.items = provData.data.map((x) => {
                        x['showCheck'] = true;
                        x['checked'] = false;
                        // y.amount = Utils.currencyFormat(y.amount, '');

                        if(x.currency == 'MXN'){
                            x.total_mxn = Utils.currencyFormat(x.amount, '');
                            x.total_usd = Utils.currencyFormat(0, '');
                            x.amount_mxn = x.amount;
                            this.expensesGrandTotal = this.expensesGrandTotal + x.amount;
                        }else{
                            x.total_usd = Utils.currencyFormat(x.amount, '');
                            x.total_mxn = Utils.currencyFormat(this.subtotalSpecialExpense(x.amount, x.currency), '');
                            x.amount_usd = x.amount;
                            this.expensesGrandTotal = this.expensesGrandTotal + this.subtotalSpecialExpense(x.amount, x.currency);
                        }

                        x.date = Utils.globalDateFormat(x.date);
                        x.due_date = Utils.globalDateFormat(x.due_date);

                        //if type payment checkbox is disabled
                        x['disableCheck'] = false; 
                        if(x.type == 'PAYMENT'){
                            x['disableCheck'] = true; 

                        }else{
                            subtotalCheckable = subtotalCheckable + this.subtotalSpecialExpense(x.amount, x.currency);
                        }

                        return x;
                    });
                    expenseItems.push({
                        title: provData.name,
                        total: parseFloat(provData.total),
                        tableData: tableProps,
                    })
                }
                expenseItems = Utils.sortObjectArray(expenseItems, 'title');
                this.expensesListData.push({
                    title: fullItem.ot,
                    total: parseFloat(fullItem.total),
                    expenseItem:expenseItems
                });
            });
            this.expensesListData = Utils.sortObjectArray(this.expensesListData, 'title');

            expenses = Utils.sortObjectArray(expenses, 'ot');
            //custom sort chronos fullfiltments sdola jdudlsidjdldidj dkdijd ddoowiw pwo 
            if(this.$store.state.business == 'chronos-fulfillment-sa-de-cv'){
                expenses = this.sortChronosFulfillment(expenses, 'ot');
                this.expensesListData = this.sortChronosFulfillment(this.expensesListData, 'title')
            }
            // this.expensesListData = this.expensesListData.reverse();
            // this.tableExpensesProps.items = expenses.map((x) => {
                

            //     x.date = x.ot;
            //     x.items = x.data.map((y) => {uno dos tres cua. ds
            //         y['showCheck'] = true;
            //         y['checked'] = false;
            //         // y.amount = Utils.currencyFormat(y.amount, '');

            //         if(y.currency == 'MXN'){
            //             y.total_mxn = Utils.currencyFormat(y.amount, '');
            //             y.total_usd = Utils.currencyFormat(0, '');
            //             y.amount_mxn = y.amount;
            //             this.expensesGrandTotal = this.expensesGrandTotal + y.amount;
            //         }else{
            //             y.total_usd = Utils.currencyFormat(y.amount, '');
            //             y.total_mxn = Utils.currencyFormat(this.subtotalSpecialExpense(y.amount, y.currency), '');
            //             y.amount_usd = y.amount;
            //             this.expensesGrandTotal = this.expensesGrandTotal + this.subtotalSpecialExpense(y.amount, y.currency);
            //         }

            //         y.date = Utils.globalDateFormat(y.date);
            //         y.due_date = Utils.globalDateFormat(y.due_date);

            //         //if type payment checkbox is disabled
            //         y['disableCheck'] = false; 
            //         if(y.type == 'PAYMENT'){
            //             y['disableCheck'] = true; 

            //         }else{
            //             subtotalCheckable = subtotalCheckable + this.subtotalSpecialExpense(y.amount, y.currency);
            //         }
                    
                    
            //     })

            //     return x;
            // });
            // //mock
            
            
            this.tableExpensesBalancesProps.items=[];
            //push OT rows
            expenses.forEach(expense => {
                let payed = 0;
                for (let i = 0; i < expense.data.length; i++) {
                    const items = expense.data[i];
                    for (let j = 0; j < items.data.length; j++) {
                        const expData = items.data[j];
                        if(expData.type == 'PAYMENT'){
                            if(expData.currency == 'MXN'){
                                // y.total_mxn = Utils.currencyFormat(y.amount, '');
                                // y.total_usd = Utils.currencyFormat(0, '');
                                // y.amount_mxn = y.amount;
                                payed = payed + expData.amount;
                            }else{
                                // y.total_usd = Utils.currencyFormat(y.amount, '');
                                // y.total_mxn = Utils.currencyFormat(this.subtotalSpecialExpense(y.amount, y.currency), '');
                                // y.amount_usd = y.amount;
                                payed = payed + this.subtotalSpecialExpense(expData.amount, expData.currency);
                            }

                        }
                    }
                }
                this.tableExpensesBalancesProps.items.push({
                    title: `cxp autorizadas ${expense.ot}`,
                    total_usd: '',//Utils.currencyFormat(expense.total, ''),
                    total_mxn: Utils.currencyFormat(payed, ''),
                    showCheck:false,
                    usd: '',//parseFloat(payed),
                    total: parseFloat(payed),
                })
            });
            console.log()
            const weekText = this.weeks.find((x) => x.value == this.selectedWeek)??' ';
            //push total
            this.tableExpensesBalancesProps.items.push(
                // {
                //     title: 'TOTAL PAGOS AUTORIZADOS',
                //     total_usd: Utils.currencyFormat(requestData.expenses.subtotal.usd, ''),
                //     total_mxn: Utils.currencyFormat(requestData.expenses.subtotal.mxn, ''),
                //     showCheck:false,
                //     usd: requestData.expenses.subtotal.usd,
                //     mxn: requestData.expenses.subtotal.mxn,
                // },
                {
                    title: `TOTAL AUTORIZADO CXP SEMANA #${weekText.text.split(" ")[1]}`,
                    total_usd: '',
                    total_mxn: Utils.currencyFormat(requestData.expenses.total, ''),
                    showCheck:false,
                    usd: '',
                    total: parseFloat(requestData.expenses.total),
                },
                {
                    title: `SALDO FINAL CXP SEMANA #${weekText.text.split(" ")[1]}`,
                    total_usd: '',
                    total_mxn: Utils.currencyFormat(this.expensesGrandTotal, ''),
                    showCheck:false,
                    usd: '',
                    total: parseFloat(this.expensesGrandTotal),
                    total_raw: parseFloat(this.expensesGrandTotal),
                },
                // {
                //     title: 'TOTAL CXP',
                //     total_usd: '',
                //     total_mxn: Utils.currencyFormat(subtotalCheckable, ''),
                //     showCheck:false,
                //     usd: '',
                //     mxn: subtotalCheckable,
                // },
                // {
                //     title: 'SALDO TOTAL CXP',
                //     total_mxn: Utils.currencyFormat(requestData.expenses.total, ''),
                //     setBold:true,
                //     showCheck:false,
                //     total: parseFloat(requestData.expenses.total),
                // }
            );
            //update row  => "SALDO FINAL CXP SEMANA #"
            this.updateFinalBalanceExpensesV2Row();

        },

        processRequest(requestData){

            if(this.selectedFilter == 'payments'){
                this.currentCurrencyValue = requestData.current_currency.value;
                requestData[`current_currency`] = null;
                requestData[`expenses`] = requestData;
                requestData[`final_balances`] = null;
                requestData[`incomes`] = null;
                requestData[`initial_balances`] = null;
                this.processRequestExpenses(requestData);
                return;
            }

            //sort by date
            requestData = this.sortData(requestData, 'date');

            // requestData = this.getMonk();
            

            this.initialBalanceTitle = `DOF ${Utils.globalDateFormat(requestData.current_currency.date)} 1 USD = ${Utils.currencyFormat(requestData.current_currency.value, 'MXN', 4)}`
            this.currentCurrencyValue = requestData.current_currency.value;
            //initial balance table
            this.tableInitialBalancesProps.items = requestData.initial_balances.data.map((x) => {

                x.total_usd = Utils.currencyFormat(x.subtotal.usd, '');
                x.total_mxn = Utils.currencyFormat(x.subtotal.mxn, '');
                x.total = Utils.currencyFormat(x.total, '');
                return x;
            });
            //set total
            // this.tableInitialBalancesProps.items.push({
            //     bank_account_name: 'Saldo',
            //     total: Utils.currencyFormat(requestData.initial_balances.total, '')
            // })
            this.totalInitialBalanceValue = Utils.currencyFormat(requestData.initial_balances.total, '');




            //income
            let totalIncomeMxn = 0;
            let totalIncomeUsd = 0;
            let grandIncomeTotal = 0;
            this.tableIncomesProps.items = requestData.incomes.data.incomes.map((x) => {

                // x.amount = Utils.currencyFormat(x.amount, '');

                if(x.currency == 'MXN'){
                    x.total_mxn = Utils.currencyFormat(x.amount, '');
                    totalIncomeMxn = totalIncomeMxn + x.amount;
                    x.total_usd = Utils.currencyFormat(0, '');
                    x.amount_mxn = x.amount;
                }else{
                    x.total_usd = Utils.currencyFormat(x.amount, '');
                    totalIncomeUsd = totalIncomeUsd + x.amount;
                    x.total_mxn = Utils.currencyFormat(this.subtotalSpecialExpense(x.amount, x.currency), '', '');
                    x.amount_usd = x.amount;
                }

                x.date = Utils.globalDateFormat(x.date)
                grandIncomeTotal = grandIncomeTotal + this.subtotalSpecialExpense(x.amount, x.currency);



                return x;
            });
            if(this.tableIncomesProps.items.length > 0){
                //set totals
                this.tableIncomesProps.items.push({
                    date: 'Subtotales',
                    total_usd: Utils.currencyFormat(totalIncomeUsd, ''),
                    total_mxn: Utils.currencyFormat(totalIncomeMxn, '')
                });
                // this.tableIncomesProps.items.push({
                //     date: 'Totales',
                //     total_mxn: Utils.currencyFormat(requestData.incomes.total, '')
                // });
            }

            this.totalIncomeValue = Utils.currencyFormat(grandIncomeTotal, '');

            //other income
            let totalOtherIncomeMxn = 0;
            let totalOtherIncomeUsd = 0;
            let grandOtherIncomeTotal = 0;
            this.tableOtherIncomesProps.items = requestData?.incomes?.data?.other_incomes?.map((x) => {

                // x.amount = Utils.currencyFormat(x.amount, '');

                if(x.currency == 'MXN'){
                    x.total_mxn = Utils.currencyFormat(x.amount, '');
                    totalOtherIncomeMxn = totalOtherIncomeMxn + x.amount;
                    x.total_usd = Utils.currencyFormat(0, '');
                    x.amount_mxn = x.amount;
                }else{
                    x.total_usd = Utils.currencyFormat(x.amount, '');
                    totalOtherIncomeUsd = totalOtherIncomeUsd + x.amount;
                    x.total_mxn = Utils.currencyFormat(this.subtotalSpecialExpense(x.amount, x.currency), '', '');
                    x.amount_usd = x.amount
                }

                x.date = Utils.globalDateFormat(x.date);

                grandOtherIncomeTotal = grandOtherIncomeTotal + this.subtotalSpecialExpense(x.amount, x.currency);


                return x;
            })??[];
            if(this.tableOtherIncomesProps.items.length > 0){
                //set totals
                this.tableOtherIncomesProps.items.push({
                    date: 'Subtotales',
                    total_usd: Utils.currencyFormat(totalOtherIncomeUsd, ''),
                    total_mxn: Utils.currencyFormat(totalOtherIncomeMxn, '')
                });
                // this.tableOtherIncomesProps.items.push({
                //     date: 'Totales',
                //     total_mxn: Utils.currencyFormat(requestData.incomes.total, '')
                // });
            }
            this.totalOtherIncomeValue = Utils.currencyFormat(grandOtherIncomeTotal, '');

            //expenses
            this.processRequestExpenses(requestData);

            //final balance
            this.tableFinalBalancesProps.items = requestData.final_balances.data.map((x) => {
                // x.bank_account_name
                x.total_usd = Utils.currencyFormat(x.subtotal.usd, '');
                x.total_mxn = Utils.currencyFormat(x.subtotal.mxn, '');
                x.total = Utils.currencyFormat(x.total, '');
                return x
            });
            //add total
            // this.tableFinalBalancesProps.items.push({
            //     bank_account_name: 'Saldo Final',
            //     total: Utils.currencyFormat(requestData.final_balances.total, ''),
            //     total_raw: parseFloat(requestData.final_balances.total),
            //     setBold:true,
            // });
            this.lastTotal = Utils.currencyFormat(requestData.final_balances.total, '');


        },
       
		index() {
            // // console.log(this.$router)
            if(!this.validateRequest())
                return;
                
            this.loading = true;

            this.tableInitialBalancesProps.items = [];
            this.tableIncomesProps.items = [];
            this.tableOtherIncomesProps.items = [];
            this.tableExpensesProps.items = [];
            this.tableExpensesBalancesProps.items = [];
            this.tableFinalBalancesProps.items = [];
            this.initialBalanceTitle = `-`
            this.currentCurrencyValue = 0;
            this.totalInitialBalanceValue = 0;
            this.totalIncomeValue= 0;
            this.totalOtherIncomeValue = 0;
            this.expensesGrandTotal = 0;
            this.lastTotal = 0;


        

            const datesSelected = this.getSelectedDates();

            let resultRequest = null;
			//call api
            if(this.selectedFilter == 'all')
                resultRequest = this.$api.report.reportPeriodBalance(this.$store.state.business, datesSelected.start_date, datesSelected.end_date)
            else
                resultRequest = this.$api.report.reportPeriodBalancePayments(this.$store.state.business, datesSelected.start_date, datesSelected.end_date)

				resultRequest.then((resp) =>{



                    this.processRequest(resp.data)



					
				})
				.catch((error) =>{
					console.log(error);
				})
				.finally(() => {
                    this.loading = false;
				})
			;
           
		},

        processExpensesData(data)
        {
            let result = [];
            Object.keys(data).forEach(keyOT => {
                let provsList = [];
                Object.keys(data[keyOT].data).forEach(keyProv => {
                    provsList.push({
                        name: keyProv, total: data[keyOT].data[keyProv].total, data: data[keyOT].data[keyProv].data
                    })
                })
                result.push(
                    {ot: keyOT, total: data[keyOT].total, data: provsList}
                )
            });
            // if(this.selectedFilter == 'payments'){
            //     result = this.expensesOnlyPayments(result);
            // }

            // console.log(result);

            return result;
        },

        
        getYears()
        {
            this.years = [];
            let now = new Date();
            now.setHours(0,0,0,0)
            const year = now.getFullYear();
            let addNext = 0;
            if(now.getDate() >= 20 && now.getMonth() == 11){
                addNext = 1
            }
            if(this.selectedYear == "")
                this.selectedYear = ""+year;
            for (let i = 2022; i <= year+addNext; i++) {
                this.years.push({text: ""+i, value: ""+i});
            }
            
        },

        validateRequest(){
            if(this.selectedYear == '' || this.selectedYear == null || this.selectedYear == undefined)
                return false;
            if(this.selectedWeek == '' || this.selectedWeek == null || this.selectedWeek == undefined)
                return false;
            return true;
        },

        expensesOnlyPayments(expenses){
            for (let i = 0; i < expenses.length; i++) {
                expenses[i].data = expenses[i].data.filter((x) => x.type == 'PAYMENT')
            }

            //clear empty
            expenses = expenses.filter((x) => x.data.length > 0);
            return expenses;
        },

        getTotalTableRows(){
            let totalAutorized = this.tableExpensesBalancesProps.items.find((x) => x.title.includes("TOTAL AUTORIZADO CXP SEMANA"));
            let finalTotal = this.tableExpensesBalancesProps.items.find((x) => x.title.includes("SALDO FINAL CXP SEMANA"));
            const weekText = this.weeks.find((x) => x.value == this.selectedWeek)??' ';

            return {totalAutorized: parseFloat(parseFloat(totalAutorized.total).toFixed(2)), finalTotal: parseFloat(parseFloat(finalTotal.total).toFixed(2)), period:weekText.text.split(" ",)[1]};
        },

        corpExport()
        {
            if(!this.validateRequest())
                return;
            
            const datesSelected = this.getSelectedDates();

            this.exportBtnData.loading = true;
            this.$api.report.exportReportPeriodBalancePayments(this.$store.state.business, datesSelected.start_date, datesSelected.end_date)
                .then((resp) => {
                    const fileURL = window.URL.createObjectURL(new Blob([resp.data]));
                    const fileLink = document.createElement("a");
                    fileLink.href = fileURL;
                    fileLink.setAttribute(
                    "download",
                    `flujo_semanal_corporativo_${this.$store.state.business}_${datesSelected.start_date}_${datesSelected.end_date}.xlsx`
                    );
                    document.body.appendChild(fileLink);
                    fileLink.click();
                })
                .catch((error) => {
                    console.log(error);
                })
                .finally(() => {
                    this.exportBtnData.loading = false;
                })
            ;
        },



        export()
        {
            console.log(this.getTotalTableRows());
           
            if(!this.validateRequest())
                return;
            
            const datesSelected = this.getSelectedDates();

            this.exportBtnData.loading = true;
            const totals = this.getTotalTableRows();
            this.$api.report.exportReportPeriodBalance(this.$store.state.business, datesSelected.start_date, datesSelected.end_date, totals.totalAutorized, totals.finalTotal, totals.period)
                .then((resp) => {
                    const fileURL = window.URL.createObjectURL(new Blob([resp.data]));
                    const fileLink = document.createElement("a");
                    fileLink.href = fileURL;
                    fileLink.setAttribute(
                    "download",
                    `flujo_semanal_${this.$store.state.business}_${datesSelected.start_date}_${datesSelected.end_date}.xlsx`
                    );
                    document.body.appendChild(fileLink);
                    fileLink.click();
                })
                .catch((error) => {
                    console.log(error);
                })
                .finally(() => {
                    this.exportBtnData.loading = false;
                })
            ;
        },

        pdf(){
            if(!this.validateRequest())
                return;

            const datesSelected = this.getSelectedDates();
            this.pdfBtnData.loading = true;
            const totals = this.getTotalTableRows();
            this.$api.report.pdfReportPeriodBalance(this.$store.state.business, datesSelected.start_date, datesSelected.end_date, totals.totalAutorized, totals.finalTotal, totals.period)
                .then((resp) => {
                   const fileURL = window.URL.createObjectURL(new Blob([resp.data]));
                    const fileLink = document.createElement("a");
                    fileLink.href = fileURL;
                    fileLink.setAttribute(
                    "download",
                    `flujo_semanal_${this.$store.state.business}_${datesSelected.start_date}_${datesSelected.end_date}.pdf`
                    );
                    document.body.appendChild(fileLink);
                    fileLink.click();
                })
                .catch((error) => {
                    console.log(error);
                })
                .finally(() => {
                    this.pdfBtnData.loading = false;
                })
            ;
        },

        


       

    }
}
</script>


<style lang="scss">
    .parent-expansion-custom .v-expansion-panel--active > .v-expansion-panel-header{
        min-height: 36px;
    }
    .expand-custom .v-expansion-panel-content__wrap{
        padding: 0;
    }
    tr:has(td > span.week-report-expenses-special-row) {
        td{
            border-bottom: none !important;
        }
    }
    // td {
    //     &:has(> span.week-report-expenses-special-row) {
    //     border-bottom: none !important;
    //     }
    // }
    .v-data-table__expanded__content{
        box-shadow: none !important;
    }
    .table-line-height{
        line-height: 1.2rem !important;
    }

    .f-width{
        min-width: -webkit-fill-available;
    }

    .hide-header-table-custom{
        thead{
            // display: table-footer-group;
            visibility: collapse;
        }
    }

    .table-f-size{
        td{
            size: 0.65rem !important;
        }
    }
    .week-report{
        &-expenses-summary-table{
            tbody tr{
                background: #eeeeee !important;
            }
        }
        &-expenses-checked-number{
            font-weight: 500;
            color: #259CE6;
        }
        &-expenses-check-container{
            display: flex;
            align-items: center;
            .v-input{
                margin-top: 0px !important;
                padding-top: 0px !important;
                margin-right: 0.5rem;
            }
        }
        &-title{
            padding: 10px 10px;
            background-color: #323433;
            font-weight: bold;
            font-size: 1rem;
            color: whitesmoke;
        }

        &-expenses-special-row{
            margin-left: -15px;
        }

        &-concepts-header{
            border-bottom: black solid 2px;
        }


        &-concept{
            color: #000;
            font-weight: bold;
            font-size: .8rem;
        }
        &-price{
            color: unset;
            font-weight: 500;
            font-size: .8rem;
        }
        &-total{
            font-weight: bold;
            font-size: .9rem;
        }


        &-subtitles-container{
            display: flex;
            justify-content: space-between;
            background-color: #FFF2A3;
            padding: 0.5rem 0.5rem;
            font-weight: 700;
            font-size: 0.75rem;

            
        }
        &-subtitles-currency{
            font-size: 0.70rem;

        }



        &-cxp-subtitles-container{
            display: flex;
            justify-content: space-between;
            background-color: #E4E4E4;
            padding: 0.4rem 0.5rem;
            font-weight: 700;
            font-size: 0.75rem;

        }


        &-cxp-subitem-expan{
            border-radius: 0px;
            border-bottom: 1px solid var(--v-line-base);
            button{
                padding: 2px 12px;
                min-height: 36px;
            }
        }


        &-cxp-subitem-icon-cont{
            display: flex;
            align-items: center;
            &-text{
                color: #00000099;
                font-size: 0.7rem;
                font-weight: 700;
            }
        }
    }
</style>